import icons from './customIcons.js';

var utils = {};
var VEHICLE_ORDER_APP_CONFIG = {
  img: icons.teslaIconBase64,
  title: 'Vehicle Orders',
  href: '/vehicle-order'
};
var AOS_APP_CONFIG = {
  img: icons.teslaIconBase64,
  title: 'Accounts',
  href: '/'
};
var APP_CONFIG_MAP = {
  'Account OS': AOS_APP_CONFIG,
  firebolt: {
    img: icons.teslaIconBase64,
    title: 'Communications',
    href: '/communications'
  },
  'Ownership Admin Tool': AOS_APP_CONFIG,
  'Vehicle Routing Plan': VEHICLE_ORDER_APP_CONFIG,
  'Vehicle Cancellations': VEHICLE_ORDER_APP_CONFIG,
  'Match Tool': VEHICLE_ORDER_APP_CONFIG,
  'VRL Lock Tool': VEHICLE_ORDER_APP_CONFIG,
  'Vehicle Dispatch': VEHICLE_ORDER_APP_CONFIG,
  'Delivery Planner': VEHICLE_ORDER_APP_CONFIG,
  'Soft Match Plan': VEHICLE_ORDER_APP_CONFIG,
  'Cancel and Refund Tool': VEHICLE_ORDER_APP_CONFIG
};
utils.transformAppSwitcherProps = function (appSwitcherProps) {
  if (!appSwitcherProps || !(appSwitcherProps !== null && appSwitcherProps !== void 0 && appSwitcherProps.applications)) {
    return [];
  }
  var appsSet = new Set();
  var transformed = [];
  appSwitcherProps === null || appSwitcherProps === void 0 ? void 0 : appSwitcherProps.applications.forEach(function (app) {
    var appConfig = APP_CONFIG_MAP[app];
    if (appConfig && !appsSet.has(appConfig === null || appConfig === void 0 ? void 0 : appConfig.title)) {
      appsSet.add(appConfig === null || appConfig === void 0 ? void 0 : appConfig.title);
      transformed.push(appConfig);
    }
  });
  return transformed.sort(function (a, b) {
    return a.title > b.title ? 1 : -1;
  });
};

export { utils as default };
